import { GetServerSideProps } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import HeaderWithBackButton from '@/components/HeaderWithBackButton';
import WelcomeHands from '@/components/icons/WelcomeHands';
import LanguageSelector from '@/components/LanguageSelector';
import Paragraph, { VARIANT } from '@/components/Paragraph';
import SocialMetaTags from '@/components/SocialMetaTags';
import { DEFAULT_APP_DESCRIPTION, DEFAULT_SELECT_LANGUAGE, DEFAULT_WELCOME_DEHAAT, HOME_PAGE_TITLE, LOCALE_COOKIE_NAME } from '@/constants/common';
import languages from '@/constants/languages';
interface Props {
  currentLangPref: string | null;
  title: string;
}
const LanguagePage = ({
  currentLangPref,
  title
}: Props) => {
  const {
    t
  } = useTranslation('language');
  const {
    back
  } = useRouter();
  const isLanguageAlreadySet = currentLangPref != null;
  const appDescription = isLanguageAlreadySet ? t('common:app_description') : DEFAULT_APP_DESCRIPTION;
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="language.tsx">
        <meta name="title" content={title} data-sentry-element="meta" data-sentry-source-file="language.tsx" />
        <meta name="description" content={appDescription} data-sentry-element="meta" data-sentry-source-file="language.tsx" />
      </Head>
      <SocialMetaTags title={title} description={appDescription} data-sentry-element="SocialMetaTags" data-sentry-source-file="language.tsx" />
      <main className="bg-neutral-10 h-screen relative">
        {isLanguageAlreadySet && <HeaderWithBackButton heading={t('language_header')} showHomeIcon={false} showProfileIcon={false} onBackClick={() => back()} />}
        <section className={`bg-white h-full m-auto max-w-7xl px-4 w-full ${isLanguageAlreadySet ? 'pt-16' : ''}`}>
          {!isLanguageAlreadySet && <div className="bg-white flex items-center justify-center py-6 w-full">
              <div>
                <WelcomeHands className="mx-4 fill-black" />
              </div>
              <h5 className="text-neutral-90">
                {isLanguageAlreadySet ? t('welcome') : DEFAULT_WELCOME_DEHAAT}
              </h5>
            </div>}
          <div>
            {!isLanguageAlreadySet && <Paragraph className="sm:text-center" isHighlighted variant={VARIANT.MEDIUM}>
                {isLanguageAlreadySet ? t('select_language') : DEFAULT_SELECT_LANGUAGE}
              </Paragraph>}
            <div className="gap-4 grid grid-cols-2 md:grid-cols-1 md:mx-6 mt-4">
              {languages.map(language => {
              return <LanguageSelector key={language.alternate_name} currentLangPref={currentLangPref} {...language} />;
            })}
            </div>
          </div>
        </section>
      </main>
    </>;
};
export const getServerSideProps: GetServerSideProps<Props> = async ({
  req: {
    cookies
  }
}) => {
  const currentLangPref = cookies[LOCALE_COOKIE_NAME] || null;
  return {
    props: {
      currentLangPref: cookies[LOCALE_COOKIE_NAME] || null,
      title: currentLangPref == null ? HOME_PAGE_TITLE : 'Select Language'
    }
  };
};
export default LanguagePage;